import { render, staticRenderFns } from "./rolePermissionTabPane.vue?vue&type=template&id=ebf15c1c&scoped=true&"
import script from "./rolePermissionTabPane.vue?vue&type=script&lang=js&"
export * from "./rolePermissionTabPane.vue?vue&type=script&lang=js&"
import style0 from "./rolePermissionTabPane.vue?vue&type=style&index=0&id=ebf15c1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf15c1c",
  null
  
)

export default component.exports